import {
  GET_USERS,
  GET_USER_PROFILE,
  ADD_USERS,
  UPDATE_USERS,
  GET_ALL_USERS,
} from '../types'

const INITIAL_STATE = {
  allUsers: [],
  addUsers: [],
  editUsers: [],
  allAdminUsers: [],
  userProfile: {},
}

const usersReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_USERS:
      return {
        ...state,
        allUsers: payload,
      }
    case GET_ALL_USERS:
      return {
        ...state,
        allAdminUsers: payload.data,
      }
    case ADD_USERS:
      return {
        ...state,
        addUsers: payload,
      }
    case UPDATE_USERS:
      return {
        ...state,
        editUsers: payload.userId,
      }
    case GET_USER_PROFILE:
      return {
        ...state,
        userProfile: payload.data,
      }
    default:
      return state
  }
}

export default usersReducer
